<template>
    <div class="audio-view">
        <MusicPlayer
            :mode="mode"
            :styles="musicPlayerStyles"
            :songs="audios"
            @new-songs="updateSongs"
        />
    </div>
</template>
<script>
    import MusicPlayer from '@/components/ui/music-player/MusicPlayer.vue'

    export default {
        name: 'AudioView',
        components: {
            MusicPlayer
        },
        props: {
            audios: {
                type: Array,
                required: false,
                default: () => []
            },
            editable: {
                type: Boolean,
                required: false,
                default: true
            }
        },
        emits: ['new-songs'],
        computed: {
            musicPlayerStyles() {
                return {
                    player: {
                        maxWidth: '100%'
                    }
                }
            },
            mode() {
                return this.editable ? 'edit' : 'view'
            }
        },
        methods: {
            updateSongs(songs) {
                this.$emit('new-songs', songs)
            }
        }
    }
</script>
<style lang="scss" scoped>
    .audio-view {
        max-width: 100%;
    }
</style>
